import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

export interface MarkAllergenAddedToChartCriteria {
  questionnaireResponseId: string;
  allergenId: string;
}

export const useMarkAllergenAddedToChart = () => {
  return useApiMutation<void, MarkAllergenAddedToChartCriteria>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.AmazonVisitIntake.MARK_ALLERGEN_ADDED_TO_CHART,
      mutationFn: async ({
        questionnaireResponseId,
        allergenId,
      }: MarkAllergenAddedToChartCriteria) => {
        await axiosInstance.put(
          `amazon-clinic/allergy-extractions/${questionnaireResponseId}/allergen-added-to-chart`,
          {
            allergenId,
          },
        );
      },
    },
  });
};
